// src/store/services/users.js
import feathersClient, { BaseModel, makeServicePlugin } from '../../feathers-client';
export class BulkImport extends BaseModel {
    constructor(data, options) {
        super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'BulkImport';
    // Define default properties here
    static instanceDefaults() {
        return {};
    }
}
const servicePath = 'bulk-import';
const servicePlugin = makeServicePlugin({
    Model: BulkImport,
    service: feathersClient.service(servicePath),
    servicePath,
});
// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: [],
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: [],
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: [],
    },
});
export default servicePlugin;
